import type {
  ReleaseNote,
  CardSortBy,
  SortDirection,
} from "../types/releaseNotes";

export const compareVersions = (a: string, b: string) => {
  const pa = a.split(".").map(Number);
  const pb = b.split(".").map(Number);

  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const diff = (pa[i] || 0) - (pb[i] || 0);

    if (diff !== 0) return diff;
  }

  return 0;
};

export const filterReleaseNotes = (
  releaseNotes: ReleaseNote[],
  search: string,
) => {
  const normalized = search.toLowerCase().trim();

  if (!normalized) return releaseNotes;

  return releaseNotes.filter((rn) =>
    [rn.title, rn.version, rn.releaseDate, rn.description]
      .join(" ")
      .toLowerCase()
      .includes(normalized),
  );
};

export const sortReleaseNotes = (
  releaseNotes: ReleaseNote[],
  sortBy: CardSortBy,
  direction: SortDirection,
) => {
  return [...releaseNotes].sort((a, b) => {
    let result = 0;

    switch (sortBy) {
      case "version":
        result = compareVersions(a.version, b.version);
        break;

      case "title":
        result = a.title.localeCompare(b.title);
        break;

      case "releaseDate":
        result =
          new Date(a.releaseDate || "").getTime() -
          new Date(b.releaseDate || "").getTime();
        break;
    }

    return direction === "asc" ? result : -result;
  });
};
